/**
 * @generated SignedSource<<0b52f00c7eb634121238f5cf58dfff63>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type paletteColorsPage_paletteQuery$variables = {
  paletteId: string;
};
export type paletteColorsPage_paletteQuery$data = {
  readonly palette: {
    readonly colors: ReadonlyArray<{
      readonly cmykHexCode: string | null;
      readonly id: string;
      readonly name: string;
      readonly rgbHexCode: string;
      readonly spotColorName: string | null;
    }>;
    readonly id: string;
    readonly isZakekeDefault: boolean;
    readonly name: string;
    readonly paletteTypeID: number;
    readonly useConversionTable: boolean;
  } | null;
};
export type paletteColorsPage_paletteQuery = {
  response: paletteColorsPage_paletteQuery$data;
  variables: paletteColorsPage_paletteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "paletteId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "paletteId"
      }
    ],
    "concreteType": "Palette",
    "kind": "LinkedField",
    "name": "palette",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "useConversionTable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paletteTypeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isZakekeDefault",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PaletteColor",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rgbHexCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cmykHexCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "spotColorName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "paletteColorsPage_paletteQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "paletteColorsPage_paletteQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "e5034db1c7afedd11ff26053e8d8ed4a",
    "id": null,
    "metadata": {},
    "name": "paletteColorsPage_paletteQuery",
    "operationKind": "query",
    "text": "query paletteColorsPage_paletteQuery(\n  $paletteId: ID!\n) {\n  palette(id: $paletteId) {\n    id\n    name\n    useConversionTable\n    paletteTypeID\n    isZakekeDefault\n    colors {\n      id\n      name\n      rgbHexCode\n      cmykHexCode\n      spotColorName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a1197ba9bdd40d913f83aa80a9ca29c";

export default node;
